import { ctx } from '@/util/context'
import { jsx, type JsxElementProps } from '@amazon/vinyl-tsx'
import { asData, type MaybeObservableValue } from '@amazon/vinyl-observable'
import { loadIcon, type IconName } from './Icons'

const { errorHandler } = ctx('Icon')

export type IconProps = JsxElementProps<'span'> & {
    readonly icon: MaybeObservableValue<IconName>
}

export function Icon(props: IconProps) {
    const { className, icon, ...rest } = props
    const icon$ = asData(icon)

    let latestIcon: IconName | undefined
    const show = (el: HTMLElement, name: IconName) => {
        if (name === latestIcon) return
        latestIcon = name
        el.setAttribute('data-icon', name)
        loadIcon(name)
            .then((iconHtml) => {
                if (name === latestIcon) el.innerHTML = iconHtml
            })
            .catch(errorHandler)
    }

    // Follows `icon` only while mounted: a render-time subscription would pin the
    // element to a long-lived source (the player's state) after it is gone.
    const el = (
        <span
            {...rest}
            className={'iconContainer ' + (className ?? '')}
            onConnect={(span) => icon$.onData((name) => show(span, name))}
        />
    ) as HTMLElement
    show(el, icon$.value)
    return el
}
